import React from 'react';

import Badge from '../common/badge';
import { TestStatus } from '../../entities/test';

interface ComponentProps {
  status: string;
}

export default function TestStatusBadge({ status }: ComponentProps) {
  let badgeStatus = 'secondary';
  let text = status;

  switch (status) {
    case TestStatus.Pending:
      badgeStatus = 'warning';
      text = 'Pending';
      break;
    case TestStatus.BloodRegistered:
      badgeStatus = 'primary';
      text = 'Blood Registered';
      break;
    case TestStatus.BloodworkDone:
      badgeStatus = 'primary';
      text = 'Bloodwork Done';
      break;
    case TestStatus.Completed:
      badgeStatus = 'success';
      text = 'Completed';
      break;
    case TestStatus.Cancelled:
      badgeStatus = 'danger';
      text = 'Cancelled';
      break;
    default:
      badgeStatus = 'secondary';
      text = status || 'Unknown';
  }

  return <Badge text={text} status={badgeStatus} />;
}
